import { render, staticRenderFns } from "./newProjectModal.vue?vue&type=template&id=4e8b3342&scoped=true&"
import script from "./newProjectModal.vue?vue&type=script&lang=ts&"
export * from "./newProjectModal.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./newProjectModal.vue?vue&type=style&index=1&id=4e8b3342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b3342",
  null
  
)

export default component.exports